(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-collection-tabs')) {
    class McCollectionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('.mc-ct__panel'));
        this.nav = this.querySelector('[data-mc-ct-nav]');
        this.prevBtn = this.querySelector('[data-mc-ct-prev]');
        this.nextBtn = this.querySelector('[data-mc-ct-next]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onResize = () => this.updateNav();
        this.onBlockSelect = (e) => this.handleBlockSelect(e);

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => this.onTabKey(e, i));
        });

        this.panels.forEach((panel) => {
          const track = panel.querySelector('.mc-ct__track');
          if (track) track.addEventListener('scroll', () => this.updateNav(), { passive: true });
        });

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollTrack(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollTrack(1));

        this.querySelectorAll('.mc-ct__form').forEach((form) => {
          form.addEventListener('submit', (e) => this.onAdd(e));
        });

        window.addEventListener('resize', this.onResize, { passive: true });
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        requestAnimationFrame(() => this.updateNav());
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get activeTrack() {
        const panel = this.panels.find((p) => !p.hidden);
        return panel ? panel.querySelector('.mc-ct__track') : null;
      }

      select(index, focus = false) {
        if (!this.tabs.length) return;
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active) {
            tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: this.reduceMotion ? 'auto' : 'smooth' });
            if (focus) tab.focus();
          }
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
        const track = this.activeTrack;
        if (track) track.scrollLeft = 0;
        this.updateNav();
      }

      onTabKey(e, i) {
        const last = this.tabs.length - 1;
        let next = null;
        if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
        if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = last;
        if (next === null) return;
        e.preventDefault();
        this.select(next, true);
      }

      handleBlockSelect(e) {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        const index = this.tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
        if (index > -1) this.select(index);
      }

      scrollTrack(dir) {
        const track = this.activeTrack;
        if (!track) return;
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }

      updateNav() {
        const track = this.activeTrack;
        if (!track || !this.nav) return;
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 2) {
          this.nav.setAttribute('data-hidden', '');
          return;
        }
        this.nav.removeAttribute('data-hidden');
        this.prevBtn.disabled = track.scrollLeft <= 2;
        this.nextBtn.disabled = track.scrollLeft >= max - 2;
      }

      async onAdd(e) {
        if (this.dataset.ajax !== 'true') return;
        e.preventDefault();

        const form = e.currentTarget;
        const btn = form.querySelector('button[type="submit"]');
        const label = form.querySelector('.mc-ct__btn-label');
        const error = form.querySelector('.mc-ct__error');
        const original = label ? label.textContent : '';
        const addUrl = (this.dataset.cartAddUrl || '/cart/add') + '.js';

        if (error) error.textContent = '';
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');

        try {
          const res = await fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const data = await res.json();

          if (!res.ok) {
            if (error) error.textContent = data.description || data.message || '';
            return;
          }

          let itemCount;
          try {
            const cartRes = await fetch((this.dataset.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } });
            const cart = await cartRes.json();
            itemCount = cart.item_count;
          } catch (_) {}

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: this.id,
              data: { source: 'mc-collection-tabs', itemCount, productId: data.product_id }
            }
          }));

          if (label) {
            label.textContent = this.dataset.addedLabel || original;
            setTimeout(() => { label.textContent = original; }, 2000);
          }
        } catch (err) {
          form.submit();
        } finally {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('mc-collection-tabs', McCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
